import {Component, computed, DestroyRef, effect, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {NbMenuService, NbSidebarService} from '@nebular/theme';
import {AuthGuard} from '../../../@core/auth.guard';
import {UserModel} from '../../../@core/models/user/user.model';
import {UsersService} from '../../../@core/services/users.service';
import {BoutonFiltreService} from '../../../@core/services/bouton-filtre.service';
import {environment} from '../../../../environments/environment';
import {MenuService} from '../../../@core/services/menu.service';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs';
import {map} from 'rxjs/operators';
import {SelectDataModel} from '../../../@core/models/selectData.model';
import {ListeService} from '../../../@core/services/liste.service';
import {UsineCtxStoreService} from '../../../@core/services/store/usine-ctx.store.service';
import {takeUntilDestroyed, toSignal} from '@angular/core/rxjs-interop';


@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {
  @Input() position = 'normal';

  public readonly boutonFiltreService = inject(BoutonFiltreService)
  public readonly usineCtxStore = inject(UsineCtxStoreService)

  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly sidebarService = inject(NbSidebarService)
  private readonly menuService = inject(NbMenuService)
  private readonly userService = inject(UsersService)
  private readonly listeService = inject(ListeService)
  private readonly authGuard = inject(AuthGuard)
  private readonly menuToggleService = inject(MenuService)
  private readonly destroyRef = inject(DestroyRef)


  private readonly $routeData = toSignal(
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {
        let route = this.activatedRoute;
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route.snapshot.data;
      }),
    ),
    { initialValue: {} },
  );

  protected readonly $displayUsine = computed<boolean>(
    () => this.$routeData()['showHeaderElement'] ?? false,
  )


  me: UserModel;
  listeUsine: Array<SelectDataModel>;

  userMenu = [{title: 'Tutoriel'}, {title: 'Applications android'}, {title: 'Déconnexion'}];

  public isOpen: boolean;
  @Output() openFilter: EventEmitter<boolean> = new EventEmitter();
  compareUsines: (o1: string | number, o2: string | number) => boolean = (o1: string | number, o2: string | number): boolean => {
    return o1 == o2; //NOSONAR on double equals since types can be mixed (any or number)
  }

  getNomComplet(): string {
    if (this.me != null) {
      return this.me.firstName + ' ' + this.me.lastName;
    }
    return '';
  }

  ngOnInit() {
    this.userService.getMe().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (me: UserModel) => {
        if (me.listDroit.length === 0) {
          this.userService.setErrorAuth(true);
          localStorage.clear();
          window.location.reload();
        } else {
          this.me = me;

          this.listeService.getListUsines().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((usines) => {
            this.listeUsine = usines;
            for (const usine of this.me.listUsines) {
              const selected = usines.find(
                (u) => u.value == usine.id //NOSONAR on double equals since types can be mixed (any or number)
              );
              if (selected) {
                this.usineCtxStore.setUsineById(selected.value);
                break; // stop after the first match
              }
            }
          });
        }
      },
      error: err => {
        localStorage.clear();
        this.userService.setErrorAuth(true);
        window.location.reload();
      },
    });

    this.menuService.onItemClick().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(menus => {
      if (menus.item.title === 'Déconnexion') {
        this.authGuard.logout().subscribe(res => {
          if (res) {
            localStorage.clear();
            window.location.reload();
          }
        });
      }
      if (menus.item.title === 'Tutoriel') {
        window.open(environment.apiPath + 'document/getInfoPdfWeb/' + 1);
      }
      if (menus.item.title === 'Applications android') {
        this.router.navigate(['listVersion'])
      }
    });

    this.menuService.onItemClick().pipe(takeUntilDestroyed(this.destroyRef)).pipe(
      filter(({tag}) => tag === 'dashboard-menu'),
      map((bag) => bag.item),
    ).subscribe(i => {
      if (i.link) {
        this.router.navigate(['accueil', 'dashboard', i.link]).then(r => {
          //empty
        });
      } else {
        this.router.navigate(['accueil'], {replaceUrl: true}).then(r => {
          //empty
        });
      }
    });

    this.isOpen = false;
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.menuToggleService.toggleOpen();
    return false;
  }

  toggleSettings(): boolean {
    this.sidebarService.toggle(false, 'settings-sidebar');
    return false;
  }

  goToHome() {
    this.menuService.navigateHome();
  }

  public clickOnFilterButton(): void {
    this.boutonFiltreService.toogleFilter();
  }
}
